module.exports = __webpack_public_path__ + "img/dfg_logo_englisch_blau_en_4c.3a1babd9.svg";